<template>
	<div class="module-manage-root d-flex flex-column">
		<div style="position:absolute;top:0;bottom:0;left:0;right:0;" class="pa-1">
            <v-data-table
                :headers="headers"
                fixed-header
                :items="modules"		   
                class="elevation-1 module-table mr-2 mb-2"
                disable-pagination
                hide-default-footer
                height="100%"
                width="100%"
                
            >
            </v-data-table>
        </div>    
	</div>
</template>

<script>
	import {default as ModuleApi} from "../../../../api/smp/sys/ModuleApi.js";
	
	export default {
		name: 'Smp-Module-Manage',
		components: {
		},
		data: () => ({
			headers:[
				{text: '编号',align: 'start',sortable: false,value: 'moduleId',width:40,divider:true},
				{ text: '代号', value: 'moduleCode',sortable: false ,width:260,divider:true},
				{ text: '名称', value: 'moduleName',sortable: false ,width:260,divider:true},
				{ text: '类型代号', value: 'moduleType',sortable: false ,width:100},
				{ text: '类型', value: 'moduleTypeName',sortable: false ,width:100},
				{ text: '部署号', value: 'deployId',sortable: false ,width:100},
				{ text: '部署服务名', value: 'serviceName',sortable: false ,width:200},
				{ text: '部署服务访问', value: 'serviceNameFlag',sortable: false ,width:80},
				{ text: '网关类型', value: 'gatewayType',sortable: false ,width:100,divider:true},
				{ text: '网关地址', value: 'gatewayAddress',sortable: false ,width:200,divider:true},
				{ text: '上下文路径', value: 'contextPath',sortable: false ,width:200}
				
			],
			modules:[]
		}),
		methods:{
			async  errMsg(title,text){
				await this.$dialog.error({
					text: text,
					title: title
				});
			},
			loadModules(){
				let me = this;
				ModuleApi.queryAllModule().then(function(resp){
					let data = resp.data;
					if((!data)||(!(data.code))||(data.code!=200)){
						let msg=data.msg;
						msg = ((!msg)||(msg==''))?'获取模块信息失败':msg;
						throw new Error(msg);
						return;
					}
					if((!data.data)){
						throw new Error('获取模块信息失败');
						return;
					}
					
					let modules = data.data.modules;
					//修改类型名
					modules.forEach(function(item){
						item.moduleTypeName = "";
						if(item.moduleType & 1)
							item.moduleTypeName += " API";
						if(item.moduleType & 2)
							item.moduleTypeName += " WEB";	
						if(item.moduleType & 4)
							item.moduleTypeName += " JOB";		
					});
					me.modules = modules;
				}).catch(function(err){
					me.errMsg('错误','获取模块信息失败:'+err.message);
				});
			}
		},
		computed:{		
		},
		created(){
			this.loadModules();
		}
	}
</script>

<style scoped>
	.module-manage-root{
		max-width:100%;
		max-height:100%;
		width:100%;
		height:100%;
	}
	.module-table{		
		width:100%;
		height:100%;
		max-width:100%;
		max-height:100%;	   
	}
</style>
